import { render, staticRenderFns } from "./SSOAuthLanding.vue?vue&type=template&id=405b4fda&"
import script from "./SSOAuthLanding.vue?vue&type=script&lang=ts&"
export * from "./SSOAuthLanding.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports